var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrayLogoStripe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 32,
    viewBox: "0 0 78 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6040_28515)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6040_28515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.0752 0H0.0751953V32H77.0752V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6040_28515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48655 12.4846C5.48655 11.6554 6.17098 11.3363 7.30478 11.3363C8.9302 11.3363 10.9835 11.8256 12.609 12.6974V7.69992C10.8339 6.99821 9.07996 6.72175 7.30478 6.72175C2.9627 6.72175 0.0751953 8.97594 0.0751953 12.74C0.0751953 18.6091 8.20291 17.6735 8.20291 20.2041C8.20291 21.1821 7.34748 21.5013 6.14962 21.5013C4.37441 21.5013 2.10712 20.7782 0.310407 19.8V24.8611C2.29962 25.7118 4.3102 26.0732 6.14962 26.0732C10.5985 26.0732 13.6571 23.883 13.6571 20.0764C13.6357 13.7394 5.48655 14.8663 5.48655 12.4846ZM19.9454 2.46875L14.7265 3.57447L14.7052 20.608C14.7052 23.7554 17.0794 26.0732 20.245 26.0732C21.9989 26.0732 23.2821 25.7542 23.9879 25.3714V21.0546C23.3036 21.3311 19.924 22.3093 19.924 19.162V11.6128H23.9879V7.08329H19.924L19.9454 2.46875ZM30.64 8.65686L30.2977 7.08329H25.6777V25.6904H31.025V13.0802C32.2867 11.4428 34.4257 11.7404 35.0889 11.9743V7.08329C34.4044 6.82806 31.9019 6.36021 30.64 8.65686ZM36.3935 7.08329H41.7621V25.6904H36.3935V7.08329ZM36.3935 5.46711L41.7621 4.31878V0.00195312L36.3935 1.12905V5.46696V5.46711ZM52.9271 6.72175C50.831 6.72175 49.4835 7.69992 48.735 8.38054L48.4567 7.06206H43.7514V31.8572L49.0985 30.7303L49.12 24.7122C49.89 25.2652 51.0235 26.0519 52.9057 26.0519C56.7344 26.0519 60.2207 22.9897 60.2207 16.2487C60.1994 10.0817 56.6702 6.72175 52.9271 6.72175ZM51.6439 21.3735C50.3819 21.3735 49.6332 20.9271 49.12 20.3741L49.0985 12.4846C49.6546 11.868 50.4247 11.4428 51.6439 11.4428C53.5902 11.4428 54.9377 13.6118 54.9377 16.3975C54.9377 19.2471 53.6115 21.3735 51.6439 21.3735ZM77.0752 16.4613C77.0752 11.0174 74.4229 6.72175 69.3539 6.72175C64.2632 6.72175 61.1832 11.0176 61.1832 16.4188C61.1832 22.8196 64.8194 26.0519 70.0382 26.0519C72.5835 26.0519 74.5085 25.4778 75.9629 24.6698V20.4167C74.5086 21.1397 72.8402 21.5863 70.7227 21.5863C68.6479 21.5863 66.8085 20.8632 66.5732 18.354H77.0325C77.0325 18.0774 77.0752 16.9716 77.0752 16.4613ZM66.509 14.4412C66.509 12.0382 67.985 11.0386 69.3325 11.0386C70.6372 11.0386 72.0275 12.0382 72.0275 14.4412H66.509Z",
    fill: "#94A3B8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6040_28515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayLogoStripe);
export default __webpack_public_path__ + "static/media/gray-logo-stripe.6b556d06bcc209f1c051bbdb399131f0.svg";
export { ForwardRef as ReactComponent };